export default __webpack_public_path__ + "static/media/banner-400x220-highend-range.9ffd2618.jpg";